import { useEffect, useRef } from 'react';

const useHover = <T extends HTMLElement>(
  mouseEnterCallback: () => void,
  mouseLeaveCallback: () => void,
): React.RefObject<T> => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const element = ref.current;
    if (element) {
      element.addEventListener('mouseenter', mouseEnterCallback);
      element.addEventListener('mouseleave', mouseLeaveCallback);

      return () => {
        element.removeEventListener('mouseenter', mouseEnterCallback);
        element.removeEventListener('mouseleave', mouseLeaveCallback);
      };
    }
  }, [mouseEnterCallback, mouseLeaveCallback]);

  return ref;
};

export default useHover;
